/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RoomDtoDetailsInner
 */
export interface RoomDtoDetailsInner {
    /**
     * Type of room detail
     * @type {string}
     * @memberof RoomDtoDetailsInner
     */
    type: RoomDtoDetailsInnerTypeEnum;
    /**
     * Value for the detail type
     * @type {number}
     * @memberof RoomDtoDetailsInner
     */
    value: number;
}


/**
 * @export
 */
export const RoomDtoDetailsInnerTypeEnum = {
    RoomCount: 'RoomCount',
    RoomSize: 'RoomSize',
    PlaceCount: 'PlaceCount'
} as const;
export type RoomDtoDetailsInnerTypeEnum = typeof RoomDtoDetailsInnerTypeEnum[keyof typeof RoomDtoDetailsInnerTypeEnum];


/**
 * Check if a given object implements the RoomDtoDetailsInner interface.
 */
export function instanceOfRoomDtoDetailsInner(value: object): value is RoomDtoDetailsInner {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function RoomDtoDetailsInnerFromJSON(json: any): RoomDtoDetailsInner {
    return RoomDtoDetailsInnerFromJSONTyped(json, false);
}

export function RoomDtoDetailsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoomDtoDetailsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'value': json['value'],
    };
}

  export function RoomDtoDetailsInnerToJSON(json: any): RoomDtoDetailsInner {
      return RoomDtoDetailsInnerToJSONTyped(json, false);
  }

  export function RoomDtoDetailsInnerToJSONTyped(value?: RoomDtoDetailsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'value': value['value'],
    };
}

